import React from 'react';
import { useState, useEffect, FunctionComponent } from "react"
import { useParams } from "react-router-dom"
import Spinner from "@murphy-frontend/web-core/components/Spinner"
import SearchBar from "@murphy-frontend/web-core/components/SearchBar"
import { dashboardTypes } from "@murphy-frontend/web-core/constants"
import { translateConstants } from "../../../common/services/translationService"
import { useGetUsers } from "@murphy-frontend/common/api/Users/Queries"
import { useGetDashboardMembers } from "../../../common/api/Dashboards/queries"
import {
    useAddMemberToDashboard,
    useRemoveMemberFromDashboard
} from "../../../common/api/Dashboards/mutations"
import { useModal } from "@murphy-frontend/web-core/contexts/ModalContext"
import { useUserPreferences } from "../../../common/contexts/UserPreferencesContext"
import { ModalConfiguration } from "@murphy-frontend/web-core/components/Modal"
import { useCustomer } from "../../../common/contexts/CustomerContext"
import { useUser } from "../../../common/contexts/UserContext"
import { CustomCheckbox } from "../../../common/components/MurphyCheckbox"
import { RxRadiobutton } from "react-icons/rx"
import { IoIosRadioButtonOff } from "react-icons/io"
import { useGetDashboard } from '../../Dashboard/queries';
import { DashboardTypes } from '@murphy-frontend/common/enums';

const styles = {
    row: {
        display: 'flex',
        width: '80rem',
        marginBottom: 20,
    },
    label: {
        width: '10rem',
        color: '#626262'
    },
    required: {
        width: '10rem',
        color: '#626262',
        fontSize: 10,
        fontStyle: 'italic'
    },
    input: {
        borderWidth: 1,
        borderColor: '#EBEBEB',
        borderStyle: 'solid',
        borderRadius: 5,
        width: '60rem'
    },
    buttonContainer: {
        borderWidh: 1,
        cursor: 'pointer',
        borderStyle: 'solid',
        borderColor: '#EBEBEB',
        width: '25rem',
        padding: 10,
        display: 'flex',
        marginBottom: 10,
        justifyContent: 'space-between',
        alignItems: 'center'
    }
}

interface DashboardProps {
    id: any;
    selectedDashboardTypeId: any;
    setSelectedDashboardTypeId: void;
    isEditMode: boolean;
    onSelectContacts: void;
    setSelectedDashboardTypeName: void;
        currentScreenSize: any;

}
const NewCrisisAccessTab: FunctionComponent = ({ id, selectedDashboardTypeId, setSelectedDashboardTypeId, isEditMode, onSelectContacts, setSelectedDashboardTypeName, currentScreenSize }: DashboardProps) => {
    const { customer } = useCustomer()
    const { user } = useUser()

    const { openModal, closeModal } = useModal()
    const { translations, language } = useUserPreferences()

    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [oldSelectedDashboardTypeId, setOldSelectedDashboardTypeId] = useState(selectedDashboardTypeId);

    const [dashboardMembers, setDashboardMembers] = useState([])
    const [currentSearchText, setCurrentSearchText] = useState("")

    const [users, setUsers] = useState([])
    const [filteredUsers, setFilteredUsers] = useState([])

    const [allDashboardTypes, setAllDashboardTypes] = useState([])

    const [dashboardNameErrorMessage, setDashboardNameErrorMessage] = useState("")


    const {
        isLoading: isLoadingUsers,
        isError: isErrorUsers,
        data: dataUsers,
        error: errorUsers
    } = useGetUsers(customer.Id);
    const {
        isLoading: isLoadingDasboard,
        isError: isErrorDashboard,
        data: dataDashboard,
        error: errorDashboard
    } = useGetDashboard(id)
    const {
        isLoading: isLoadingDasboardMembers,
        isError: isErrorDashboardMembers,
        data: dataDashboardMembers,
        refetch: refetchDashboardMembers,
        error: errorDashboardMembers
    } = useGetDashboardMembers(id, selectedDashboardTypeId);

    const { mutate: addMember, isPending: addMemberIsLoading } = useAddMemberToDashboard(id, translations)
    const { mutate: removeMember, isPending: removeMemberIsLoading } = useRemoveMemberFromDashboard(id, translations)

    const mapDashboard = rawDashboard => ({
        id: rawDashboard.dashboardid,
        name: decodeURIComponent(rawDashboard.Name),
        isarchived: rawDashboard.Arkiverad,
        dashboardtypeid: rawDashboard.DashboardTypeId
    })

    const mapDashboardMembers = members =>
        members.map(memb => ({
            id: memb.Id,
            name: memb.Name,
            customeruserid: memb.CustomerUserId.toUpperCase(),
            type: "user"
        }))

    const onSearchChanged = event => {
        const newValue = event.target.value
        setCurrentSearchText(newValue)
    }

    const onChangeDashboardTypeId = dashType => {
        setSelectedDashboardTypeId(dashType?.id);
        setSelectedDashboardTypeName(dashType?.value)
    }

    const onClickAddMember = (customerUserId: string) => {
        addMember(customerUserId)
    }

    const onClickRemoveMember = (dashboardMemberId: string) => {
        const dashBoardMember = dashboardMembers.filter(memb => memb.id === dashboardMemberId)[0]
        if (dashBoardMember.name === user.Username) {
            const modalConf: ModalConfiguration = {
                title: "Cannot delete yourself",
                body: <p>Cannot delete yourself from explicit dashboard</p>,
                buttonText: "Ok",
                type: "warning"
            }

            openModal(modalConf)
        } else {
            removeMember(dashboardMemberId)
        }
    }

    useEffect(() => {
        setAllDashboardTypes(translateConstants(language, dashboardTypes))
        if (selectedDashboardTypeId === DashboardTypes.ExplicitPermissions) {
            refetchDashboardMembers();
        }
    }, [selectedDashboardTypeId])

    useEffect(() => {
        setAllDashboardTypes(translateConstants(language, dashboardTypes))
    }, [language])

    useEffect(() => {
        if (dataDashboardMembers) {
            const membersWithPermission = dataDashboardMembers.filter(memb => memb.hasPermission === true)
            const mappedMembers = mapDashboardMembers(membersWithPermission)
            setDashboardMembers(mappedMembers);
            onSelectContacts(mappedMembers);
        }
    }, [dataDashboardMembers])

    function ErrorMessage() {
        return <p>{error}</p>
    }

    useEffect(() => {
        if (dataUsers) {
            const mappedData = dataUsers.map(p => ({
                id: p.CustomerUserId.toUpperCase(),
                name: p.Username,
                email: p.Email,
                mobile: p.Phonenumber,
                type: "user"
            }))

            mappedData.sort((a, b) => a.name - b.name)
            setUsers(mappedData)
        }
    }, [dataUsers])

    useEffect(() => {
        if (users) {
            let nonMemberUsers = users.filter(p => !dashboardMembers.map(q => q.customeruserid).includes(p.id))

            if (currentSearchText) {
                const searchValue = currentSearchText.toUpperCase()
                nonMemberUsers = nonMemberUsers.filter(p => p.name.toUpperCase().startsWith(searchValue))
            }

            setFilteredUsers(nonMemberUsers)
        }
    }, [dashboardMembers, users, currentSearchText])

    useEffect(() => {
        if (error) {
            const modalConf: ModalConfiguration = {
                title: "Error",
                body: <ErrorMessage />,
                buttonText: "Ok",
                type: "error",
                okCallback: () => {
                    setError(null)
                }
            }

            openModal(modalConf)
        }
    }, [error]);

    // useEffect(() => {
    //     if (dataDashboard) {
    //         const mappedDashboard = mapDashboard(dataDashboard)
    //         setSelectedDashboardTypeId(mappedDashboard.dashboardtypeid)
    //         setOldSelectedDashboardTypeId(mappedDashboard.dashboardtypeid)
    //     }
    // }, [dataDashboard])

    if (
        isLoading ||
        isLoadingDasboardMembers ||
        isLoadingUsers ||
        addMemberIsLoading ||
        removeMemberIsLoading
    ) {
        return <Spinner isGlobal />
    }

    const saveButtonDisabled = !!dashboardNameErrorMessage

    return (
        <div>
            <section className='header-container vertical-aligner'>
                <div className='three' />
            </section>
            <div>
                <div style={styles.row}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={styles.label}>{translations.access || "Access"}</span>
                        <span style={styles.required}>{translations.required || "required"}</span>
                    </div>
                    <div style={{ width: '60rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div style={styles.buttonContainer} onClick={() => onChangeDashboardTypeId(allDashboardTypes[0])}>

                            <label style={{ marginLeft: 10 }}>{allDashboardTypes[0]?.value}</label>
                            {selectedDashboardTypeId === allDashboardTypes[0]?.id ? <RxRadiobutton /> : <IoIosRadioButtonOff />}
                        </div>
                        <div style={styles.buttonContainer} onClick={() => onChangeDashboardTypeId(allDashboardTypes[1])}>

                            <label style={{ marginLeft: 10 }}>{allDashboardTypes[1]?.value}</label>
                            {selectedDashboardTypeId === allDashboardTypes[1]?.id ? <RxRadiobutton /> : <IoIosRadioButtonOff />}
                        </div>
                    </div>
                </div>
                {selectedDashboardTypeId === DashboardTypes.ExplicitPermissions &&
                    <div>
                        <div style={{ width: '60rem', marginLeft: '10rem' }}>
                            <SearchBar
                                val={currentSearchText}
                                showSearchIcon
                                handleChange={onSearchChanged}
                                placeholder={translations["placeholder-lang-search-action"]}
                            />
                            <div style={{ display: 'flex', flexDirection: 'row', width: '40rem', justifyContent: 'space-between', marginTop: 20 }}>
                                <label>{translations.tmpAddUser || 'Users'} ({users?.length})</label>
                                <label>{translations.operationsValda || 'Selected'} ({dashboardMembers?.length})</label>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 20, justifyContent: 'space-between' }}>

                                <div style={{ maxHeight: '25rem', overflow: 'auto' }}>

                                    {filteredUsers.map(contact => <div style={styles.buttonContainer}>
                                        <label style={{width: '20rem', overflow: 'hidden'}}>{contact.name}</label>
                                        <CustomCheckbox
                                            onChange={(id) => onClickAddMember(contact.id)}
                                            checked={false}
                                            checkedColor="#00A098"
                                            unCheckedColor="#7F7F7F"
                                        />
                                    </div>)}
                                </div>
                                <div style={{ maxHeight: '25rem', overflow: 'auto' }}>
                                    {dashboardMembers.map(contact => <div style={styles.buttonContainer}>
                                         <label style={{width: '20rem', overflow: 'hidden'}}>{contact.name}</label>
                                        <CustomCheckbox
                                            onChange={(id) => onClickRemoveMember(contact.id)}
                                            checked={true}
                                            checkedColor="#00A098"
                                            unCheckedColor="#7F7F7F"
                                        />
                                    </div>)}
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>
        </div >
    )
}

export default NewCrisisAccessTab;
